<template>
	<card class="responsive-card-table">
		<template slot="header">
			<div class="row align-items-center">
				<div class="col-12 col-md-8">
					<h4>Documenti per il cantiere ({{site.attachments.length}})</h4>
				</div>
				<div class="col-12 col-md-4">
					<image-upload 
						class="add-image w-100"
						drag
						@change="onImageChange"
						select-text="Aggiungi file" />
					<div v-if="attachmentLoading">
						<loading />
					</div>
				</div>				
			</div>
		</template>
		<el-table :data="site.attachments">
			<el-table-column
				width="60"
				fixed
				label=""
			>
				<template slot-scope="scope">
					<a :href="`/api/sites/${$route.params.id}/site-attachments/${scope.row.id}`" target="_blank" class="d-block btn btn-link text-info">
						<i class="fas fa-external-link-alt"></i>
					</a>
				</template>
			</el-table-column>
			<el-table-column
				width="400"
				fixed
				label="Nome">
				<template slot-scope="scope">
					<base-input 
						v-validate="'required'"
						:name="`${scope.row.id}orinalname`"
						:error="getError(`${scope.row.id}orinalname`)"
						placeholder="Nome del file"
						v-model="scope.row.originalname"/>
				</template>
			</el-table-column>
			<el-table-column
				prop="mimetype"
				label="Tipo di file" />
			<el-table-column
				label="Dimensione">
				<template slot-scope="scope">
					{{scope.row.size | bytes}}
				</template>
			</el-table-column>
			<!-- <el-table-column
				prop="filename"
				width="150"
				label="id" /> -->
			<el-table-column
				label="Data caricamento">
				<template slot-scope="scope">
					{{scope.row.createdAt | moment('DD/MM/YY')}}
				</template>
			</el-table-column>
			<el-table-column
				width="150"
				label="Azioni">
				<template slot-scope="scope">
						<base-button type="link" class="text-info" @click="updateAttachment({
							id: scope.row.id,
							siteId: $route.params.id,
							siteAttachment: {
								originalname: scope.row.originalname
							}
						})">
							<i class="tim-icons icon-pencil"></i>
						</base-button>

						<base-button type="link" class="text-danger" @click="deleteAttachment({
							id: scope.row.id,
							siteId: $route.params.id
						})">
							<i class="tim-icons icon-trash-simple"></i>
						</base-button>
				</template>
			</el-table-column>
		</el-table>
	</card>
</template>
<style lang="scss">
	.add-image.fileinput{
		margin:auto;
		display: block;
		text-align: right !important;
		img{
			display: none;
		}
		.btn-danger {
			display: none;
		}
	}
</style>
<script>
import {
  ImageUpload,
} from 'src/components/index';

import { mapState, mapActions } from 'vuex'
import { Table, TableColumn } from 'element-ui';

export default{
	name: 'site-attachments',
	computed: {
		...mapState({
			attachmentLoading: state => state.sites.attachmentLoading
		})
	},
	components: {
		[TableColumn.name]: TableColumn,
		[Table.name]: Table,
		ImageUpload
	},
	props: {
		site: Object
	},
	methods: {
		...mapActions('sites', {
			addAttachment: 'addAttachment',
			deleteAttachment: 'deleteAttachment',
			updateAttachment: 'updateAttachment'
		}),
		onImageChange(attachment) {
			if (attachment){
				this.addAttachment({
					siteId : this.$route.params.id,
					attachment
				});
			}
		},
		getError(fieldName) {
			return this.errors.first(fieldName);
		},
	}

}
</script>